const init = () => {
    const toggle = document.querySelector('.mobile-nav-toggle');
    if (!toggle) return;
    const header = toggle.closest('header');
    if (!header) return;

    const setOpen = (open) => {
        header.classList.toggle('menu-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        document.body.style.overflow = open ? 'hidden' : '';
    };

    toggle.addEventListener('click', () => {
        setOpen(!header.classList.contains('menu-open'));
    });

    header.querySelectorAll('.nav-stack a').forEach((link) => {
        link.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('menu-open')) {
            setOpen(false);
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
